import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { find, getOr } from 'lodash/fp';

const DefaultLocationCell = ({ dataKey, rowData, ...props }) => {
  const defaultLocation = find('isDefault', rowData[dataKey]);

  return (
    <Table.Cell {...props}>
      {getOr('None', 'inventoryLocation.name', defaultLocation)}
    </Table.Cell>
  );
};

DefaultLocationCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

DefaultLocationCell.defaultProps = {
  rowData: null
};

export default DefaultLocationCell;
